// extracted by mini-css-extract-plugin
module.exports = {"btn_base":"btn_base--CboCEa3b","toatlText":"toatlText--s5h87Tss"};